import React, { useContext } from 'react';
import laptopSprite from 'assets/icons/laptop.svg';
import TranslateContext from 'contexts/TranslateContext';
import Layout from './_layout_';

export default Universal;

function Universal(props) {
  const {
    message = 'playback_error',
  } = props;
  const translate = useContext(TranslateContext);
  const iconProps = { name: laptopSprite.id, width: 205, height: 125, viewBox: 'none' };
  const textProps = {
    color: 'white',
    size: 'fs_md',
    children: translate(message),
  };

  return <Layout {...{ iconProps, textProps }} />;
}
